// Static content used across the site
export const STAN_STRATEGY_URL = '/strategy-intensive';
export const STAN_SPEAKING_URL = '/speaking#inquiry';

export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_86d138bb-490b-4c43-8779-6497c2705276/artifacts/6i8599pe_New%20logo%20transparent.png';

// CEO Intelligence software product is on hold — company row is hidden from the
// public site. The .summit block below (AI in Action Virtual Summit presentation)
// is retained and continues to appear on the Media page as speaking content.
// Do not delete this constant: it preserves the code for future product reactivation.
export const CEO_INTELLIGENCE = {
  logo: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/hcpiookk_LOGO.png',
  logoOnDark: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/kfg7ffxd_LOGO%20TRANSPARENT.png',
  waitlistUrl: '/contact?kind=business&subject=CEO+Intelligence+Waitlist',
  summit: {
    title: 'CEO Intelligence: How to Build a Business in 1 Hour with AI',
    event: 'AI in Action Virtual Summit',
    videoId: 'fSKIK0d9jso',
    url: 'https://www.youtube.com/watch?v=fSKIK0d9jso',
    thumbnail: 'https://img.youtube.com/vi/fSKIK0d9jso/maxresdefault.jpg',
    thumbnailFallback: 'https://img.youtube.com/vi/fSKIK0d9jso/hqdefault.jpg',
  },
};

// Customer journey, the strategic architecture the site should reinforce
export const CUSTOMER_JOURNEY = [
  { label: 'Idea', body: 'You have a vision.' },
  { label: 'Foundation', body: 'Validation, brand, offer, pricing, and launch strategy — mapped with intention.' },
  { label: 'Launch Business', body: 'Your company is live, positioned, and ready to grow.' },
  { label: 'Industry Platforms', body: 'When you need vertical support, LabFounders HQ, Altura Global RE, and future venture platforms.' },
];

// NOTE: TIA_TEASER is preserved for future reactivation but no longer rendered publicly (see Companies.jsx).
export const TIA_TEASER = {
  eyebrow: 'Meet TIA (Coming Soon)',
  title: 'Your AI Business Strategist.',
  body:
    'TIA is a future AI Business Strategist designed to guide founders through building businesses, creating brands, developing strategies, and preparing for launch.',
};

export const PHOTOS = {
  // FINAL EDITORIAL PHOTOGRAPHY — filename-mapped
  homeHero: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/624q1vi8_professional%20model%20pic%204.png', // homepage hero (unchanged)
  about: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/fvpf0e23_HOMEPAGE%202ND%20IMAGE.png', // Image A — brown suit + city window (HOMEPAGE 2ND / Vision)
  aboutPage: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/5kacg89p_ABOUT%20PAGE%20MAIN%20IMAGE%20SHORT%20FORM.png', // Image B — green blazer + marble desk (ABOUT PAGE MAIN)
  media: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/l91x1zcr_6IX_5641.webp',
  companies: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/fgqhohnm_6IX_0721.webp',
  speaking: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/4wm33gmy_6IX_0693.webp',
  contact: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/14kcqizs_21-03-2025-13-31-47.webp',
  lifestyle: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/k2qy5oy8_IMG_5348.webp',
  // Upright copy of IMG_5008 (original file was stored rotated 90°)
  editorial: `${window.location.origin}/images/editorial-upright.webp`,
  work: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/4rz6n9l4_WORK%20WITH%20ME%20IMAGE.png', // WORK WITH ME IMAGE - beige suit desk writing
  red: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/uto8uetd_21-03-2025-15-49-28.webp',
  editorial2: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/s7qhupes_IMG_5329.webp',
  editorial3: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/qpcwuztx_Professional%20Photo%20black.png',
  // Page-specific overrides
  speakingPage: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/2hp66pmp_speaking%20page%20banner.png', // speaking page banner - white suit backstage audience
  resourcesPage: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/wpvs6cw2_RESOURCES%20PAGE%20DIGITAL%20PRODUCTS.png', // RESOURCES PAGE DIGITAL PRODUCTS - laptop store mock
  nowPage: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/qrcxqoq2_NOW%20Imagem%20Page.png', // NOW Imagem Page - beige suit at desk writing
  journalPage: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/1s823758_IMG_0195.jpeg', // Journal — black double-breasted blazer, gold buttons, fireplace, sconce (upright)
};
export const COMPANY_LOGOS = {
  labfounders: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/4m02q3pt_APP%20ICON%20LF%20ONLY%20TRANSPARENT.png',
  labfoundersOnLight: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/4m02q3pt_APP%20ICON%20LF%20ONLY%20TRANSPARENT.png',
  altura: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/det5b94h_Altura%20logo_Real%20Esrate-01.png',
  betweenus: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/j3rxbcle_Between%20Us%20PC%20CONVOS%20PNG.webp',
};

// External company URLs
export const COMPANY_URLS = {
  labfounders: 'https://labfoundershq.com/',
  altura: 'https://alturagroupre.com/',
  ceoIntelligence: '#', // Coming Soon
  moveMode: '#', // Coming Soon
};

// Certification page slug
export const CREDENTIALS_URL = '/credentials';

// AI Certifications (verified via CredsVerse)
export const AI_CERTIFICATIONS = [
  {
    level: 'Level 1',
    title: 'AI Systems, Governance & Compliance Professional',
    accreditor: 'AI Institute of Professional Development',
    board: 'International Board of Professional AI Accreditation (IBAI)',
    program: 'IBAI-PROV-25-0001',
    url: 'https://credsverse.com/credentials/66504c38-519c-49df-a7dc-91c87e8189a9',
  },
  {
    level: 'Level 2',
    title: 'AI Business Solutions & Integration Practitioner',
    accreditor: 'AI Institute of Professional Development',
    board: 'International Board of Professional AI Accreditation (IBAI)',
    program: 'IBAI-PROV-25-0001',
    url: 'https://credsverse.com/credentials/ed0dde5e-0e51-450e-9634-7051630e3a65',
  },
  {
    level: 'Level 3',
    title: 'AI Marketing, Communications & PR Strategist',
    accreditor: 'AI Institute of Professional Development',
    board: 'International Board of Professional AI Accreditation (IBAI)',
    program: 'IBAI-PROV-25-0001',
    url: 'https://credsverse.com/credentials/48e3db07-8697-404f-a08d-51e4b3c9167d',
  },
];

// Social links (footer)
export const SOCIAL_LINKS = {
  linkedin: 'https://www.linkedin.com/in/iamtoiawallace/',
  instagram: 'https://www.instagram.com/iamtoiawallace/',
  facebook: 'https://www.facebook.com/iamtoiawallace/',
  tiktok: 'https://www.tiktok.com/@saltnstilettos',
  linktree: 'https://linktr.ee/Iamtoiawallace',
};

// Stan Store for Digital Products
export const DIGITAL_PRODUCTS_URL = '/resources/digital-products';

export const COMPANIES = [
  {
    slug: 'labfounders-hq',
    name: 'LabFounders HQ',
    tagline: 'Laboratory Business Platform.',
    description:
      'Purpose-built software for laboratory entrepreneurs, the training, technology, and infrastructure to launch and scale their diagnostic and clinical businesses.',
    mission: 'Equip laboratory founders with the systems and knowledge required to build enduring healthcare companies.',
    vision: 'A future where independent lab founders lead the next wave of diagnostic and clinical innovation.',
    stage: 'Active',
    roadmap: 'AI-assisted lab operations, credentialed founder cohorts, capital access.',
    url: 'https://labfoundershq.com/',
    external: true,
    hasLogo: 'labfounders',
  },
  {
    slug: 'altura-global-re',
    name: 'Altura Global RE',
    tagline: 'Global Real Estate & Investment Platform.',
    description:
      'Helping people explore international real estate and global opportunities, curated markets, residency-through-property programs, and investment access for a new generation of global citizens.',
    mission: 'Open the door to borderless real estate ownership and passive investment.',
    vision: 'The premier global gateway for founders and families building wealth beyond one country.',
    stage: 'Active',
    roadmap: 'Curated markets in Portugal, Dubai, Panama, Caribbean.',
    url: 'https://alturagroupre.com/',
    external: true,
    hasLogo: 'altura',
  },
  {
    slug: 'movemode',
    name: 'Move MODE',
    tagline: 'Lifestyle Brand.',
    description:
      'Fitness, wellness, movement, and intentional living, a lifestyle brand for high-performing founders who understand that longevity, movement, and mindset are non-negotiable.',
    mission: 'Make executive-grade wellness accessible and beautiful.',
    vision: 'A quiet standard for how modern founders take care of themselves.',
    stage: 'Coming Soon',
    roadmap: 'Programming library, executive rituals, retreats.',
    url: '#',
    comingSoon: true,
  },
  {
    slug: 'between-us-convos',
    name: 'Between Us Convos',
    tagline: 'Real Love. Real Talk. Real Life. And Everything Between.',
    description:
      'A relationship and lifestyle media brand featuring honest conversations about love, dating, commitment, communication, personal growth, and building a life together.',
    mission:
      'Create a space where couples and individuals can engage in honest, relatable conversations about relationships, real-life experiences, and the journey of growing together.',
    vision:
      'Build a trusted relationship media platform where authentic stories, meaningful conversations, and different perspectives help people better understand love, partnership, and one another.',
    stage: 'Active',
    roadmap:
      'Podcast episodes, relationship conversations, couple experiences, guest interviews, reaction content, community discussions, and future live experiences.',
    url: 'https://www.youtube.com/@officialBetweenUsConvos',
    external: true,
    hasLogo: 'betweenus',
  },
  {
    slug: 'future-ventures',
    name: 'Future Ventures',
    tagline: 'The companies still being written.',
    description:
      'The next chapter of the ecosystem, technology, education, media, and infrastructure ventures in development.',
    mission: 'Build companies that quietly reshape the industries they enter.',
    vision: 'A portfolio measured not by count, but by consequence.',
    stage: 'Incubating',
    roadmap: 'To be announced.',
    url: '#',
  },
];

export const TIMELINE = [
  {
    year: '2013',
    label: 'The Beginning',
    chapter: 'The First Leap',
    title: 'Entrepreneur',
    body:
      'My entrepreneurial journey began in 2013 with the launch of I Love Signings Notary & Clerical Services. What started as a notary and clerical services business became the foundation for everything that followed, an introduction to business ownership, client service, discipline, and the responsibility of turning an idea into something real.',
    milestone: {
      kind: 'Founder Documentary',
      title: 'CEOs In The City × Toia Wallace',
      description:
        'A documented look at an earlier chapter of my entrepreneurial journey, the businesses, lessons, and experiences that laid the foundation for the founder I am today.',
      url: 'https://www.youtube.com/watch?v=3xGxhP3uEsQ&t=15s',
      cta: 'Watch the Documentary',
    },
  },
  {
    year: '2014',
    chapter: 'Learning to Build Brands',
    title: 'Retail & Wholesale Founder',
    body:
      'Expanded into retail and wholesale through a virgin hair business, an early chapter that sharpened my instincts in product sourcing, branding, marketing, sales, customer service, and building wholesale relationships. A formative season that strengthened the entrepreneurial fundamentals I still build with today.',
  },
  {
    year: '2017–2024',
    chapter: 'Helping Others Build',
    title: 'Business Consultant & Strategist',
    body:
      'Expanded from building my own businesses into helping other entrepreneurs launch, organize, and grow theirs. Through consulting, coaching, strategy, and revenue planning, I developed frameworks that helped founders move from ideas to execution, work that later influenced my educational programs, corporate training, and my transition into software.',
  },
  {
    year: '2020',
    chapter: 'The Unexpected Turning Point',
    title: 'After-Hours Beauty Spa Owner',
    body:
      'Launched an after-hours beauty spa, which later expanded into a day and after-hours spa where we added select medical beauty services alongside the existing beauty and wellness experience. It became a defining pivot, through operating and expanding this business, I was introduced to the laboratory industry, and what began as beauty and wellness quietly opened the doorway to healthcare.',
    quote: 'The spa was not the destination. It was the doorway.',
    accent: true,
  },
  {
    year: '2020–Present',
    chapter: 'Entering the Laboratory Industry',
    title: 'Laboratory Owner · JACE Laboratories',
    body:
      'Approximately eight months after launching the spa, I entered the laboratory industry and founded JACE Laboratories. The experience I gained through the spa introduced me to laboratory testing and diagnostic services, ultimately redirecting the course of my entrepreneurial journey. This chapter later led to LabFounders University, laboratory entrepreneurship education, corporate training, LabFounders HQ, and a growing community of laboratory entrepreneurs.',
  },
  {
    year: '2021–Present',
    chapter: 'Teaching What I Learned',
    title: 'Educator & Corporate Trainer',
    body:
      'Expanded into professional education and corporate training, developing curricula, teaching specialized industry knowledge, and helping professionals and entrepreneurs build confidence through education. This chapter marked the transition from business owner into educator, trainer, curriculum developer, industry mentor, and founder of educational platforms including LabFounders University.',
  },
  {
    year: '2022',
    chapter: 'Expanding Into Consumer Products',
    title: 'Beverage Founder',
    body:
      'Launched a bottled water company and continued expanding my entrepreneurial experience beyond service-based businesses. This chapter reinforced my ability to build across industries, exploring consumer products, branding, distribution, and lifestyle-based opportunities.',
  },
  {
    year: 'January 1, 2026',
    chapter: 'Writing My Story',
    title: 'Published Author',
    body:
      'Published my first book, Faith Got Me Here: My Journey from Waiting to Winning — A Transparent Journey of Trust, Transformation & Triumph. A chapter about faith, perseverance, entrepreneurship, transformation, and trusting God\u2019s timing through every season of life and business.',
    cta: { label: 'Buy on Amazon', url: 'https://www.amazon.com/dp/B0GHS19JH7' },
  },
  {
    year: '2026',
    chapter: 'Embracing Artificial Intelligence',
    title: 'AI Business Transformation Strategist',
    body:
      'Expanded into artificial intelligence and earned professional certifications across AI systems, governance and compliance, business integration, and marketing and communications. This chapter marked the evolution from traditional business strategy into AI-powered entrepreneurship, innovation, and transformation.',
    milestone: {
      kind: 'AI in Action Virtual Summit',
      title: 'CEO Intelligence: How to Build a Business in 1 Hour with AI',
      description:
        'The public introduction of the CEO Intelligence framework and my transition into AI-powered business education.',
      url: 'https://www.youtube.com/watch?v=fSKIK0d9jso',
      cta: 'Watch the Summit Presentation',
    },
  },
  {
    year: '2026',
    chapter: 'Building the Future',
    title: 'Software Founder',
    body:
      'Transitioned from primarily delivering strategy, education, and training into building scalable software platforms, an ecosystem of companies designed to compound and outlast an era.',
    ventures: [
      { name: 'LabFounders HQ', desc: 'Purpose-built software for laboratory entrepreneurs.' },
      { name: 'Altura Global RE', desc: 'Global real estate and opportunities platform.' },
      { name: 'Move MODE', desc: 'Fitness and wellness lifestyle brand.' },
    ],
  },
];

export const TIMELINE_OUTRO = {
  eyebrow: 'The Journey Continues',
  body:
    'Every chapter prepared me for the next. Today, I continue building companies, developing technology, educating entrepreneurs, speaking, writing, and creating opportunities that help others turn ideas into impact.',
  closing: 'The story is still being written.',
};

export const SPEAKING_TOPICS = [
  'Artificial Intelligence & Business',
  'Entrepreneurship',
  'Business Strategy',
  'Founder Mindset',
  'Healthcare Entrepreneurship',
  'Innovation & Technology',
  "Women's Leadership",
  'Building Businesses with AI',
];

export const MEDIA_LOGOS = [
  'VOYAGEMIA', 'VOYAGE JACKSONVILLE', 'SHOUTOUT ATLANTA', 'VOYAGEATL',
  'BOLD JOURNEY', 'CANVASREBEL', 'AI SUMMIT', 'CEOs IN THE CITY',
];

// New, Media & Press assets
export const DOCUMENTARY = {
  title: 'CEOs In The City × Toia Wallace',
  subtitle: 'Documentary',
  url: 'https://www.youtube.com/watch?v=3xGxhP3uEsQ&t=15s',
  videoId: '3xGxhP3uEsQ',
  thumbnail: 'https://img.youtube.com/vi/3xGxhP3uEsQ/maxresdefault.jpg',
  thumbnailFallback: 'https://img.youtube.com/vi/3xGxhP3uEsQ/hqdefault.jpg',
  description:
    'This documentary captures an early chapter of my entrepreneurial journey, from becoming a full-time entrepreneur to building multiple businesses. Although my portfolio has evolved significantly since it was filmed, it represents the foundation of everything I\u2019m building today.',
};

export const PUBLICATIONS = [
  {
    name: 'VoyageMIA',
    title: 'Inspiring Conversations with Toia Wallace of 9-5 Grind Consulting',
    url: 'https://voyagemia.com/interview/inspiring-conversations-with-toia-wallace-of-9-5-grind-consulting/',
    year: '2019',
  },
  {
    name: 'Voyage Jacksonville',
    title: 'Meet Toia Wallace of Jace Laboratories & Screening and JL Consulting Group',
    url: 'https://voyagejacksonville.com/interview/community-highlights-meet-toia-wallace-of-jace-laboratories-screening-jl-consulting-group/',
    year: '2021',
  },
  {
    name: 'Shoutout Atlanta',
    title: 'Meet Toia Wallace | Executive Director at JACE Laboratories & Screening',
    url: 'https://shoutoutatlanta.com/meet-toia-wallace-executive-director-at-jace-laboratories-screening-drug-testing-center/',
    year: '2022',
  },
  {
    name: 'VoyageATL',
    title: 'Inspiring Conversations with Toia Wallace of Glow Beauty Esthetics',
    url: 'https://voyageatl.com/interview/inspiring-conversations-with-toia-wallace-of-glow-beauty-esthetics/',
    year: '2022',
  },
  {
    name: 'Bold Journey',
    title: 'Meet Toia Wallace',
    url: 'https://boldjourney.com/meet-toia-wallace/',
    year: '2024',
  },
  {
    name: 'CanvasRebel',
    title: 'Meet Toia Wallace',
    url: 'https://canvasrebel.com/meet-toia-wallace/',
    year: '2024',
  },
];

export const BOOK = {
  title: 'Faith Got Me Here',
  subtitle: 'My Journey from Waiting to Winning: A Transparent Journey of Trust, Transformation & Triumph',
  publishedDate: 'January 1, 2026',
  description:
    'Faith Got Me Here shares my journey of faith, perseverance, entrepreneurship, and trusting God\u2019s timing through every season of building a purpose-driven life.',
  url: 'https://www.amazon.com/dp/B0GHS19JH7',
  ctaLabel: 'Buy on Amazon',
  cover: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/zz137mrc_Front%20Cover.webp',
};

export const COURSES = {
  intro:
    'Education has always been a core part of my mission. Through online learning, speaking, and professional training, I help aspiring entrepreneurs and professionals gain the knowledge and confidence to launch businesses, develop new skills, and create opportunities for long-term success.',
  featured: {
    title: 'DOT Qualification Specimen Collector Training',
    platform: 'Available on Udemy',
    instructor: 'Toia Wallace',
    description:
      'A professional training program designed to prepare current and aspiring specimen collectors with the knowledge required to perform Department of Transportation (DOT) urine specimen collections in accordance with federal regulations. This course serves as the theory portion of the qualification process and is part of my educational portfolio.',
    ctaLabel: 'Enroll on Udemy',
    url: 'https://www.udemy.com/user/toia-wallace-2/',
  },
  future: [
    { name: 'Business Strategy Intensives', url: '/strategy-intensive' },
    { name: 'AI Certifications', url: '/credentials' },
    { name: 'Executive Workshops', url: '#', comingSoon: true },
    { name: 'Laboratory Business Training', url: 'https://labfoundershq.com/' },
    { name: 'Digital Products', url: '/resources/digital-products' },
    { name: 'Founder Education Resources', url: '/resources' },
  ],
};

export const MILESTONES_2026 = [
  { date: 'January 1, 2026', kind: 'Published', title: 'Faith Got Me Here' },
  { date: '2026', kind: 'Documentary Released', title: 'CEOs In The City documentary released.' },
  { date: '2026', kind: 'AI in Action Summit', title: 'Presented: CEO Intelligence, How to Build a Business in 1 Hour with AI' },
];

export const MEDIA_DOWNLOADS = [
  { key: 'speaker-sheet', label: 'Speaker One Sheet', hint: 'PDF · updated seasonally' },
  { key: 'media-kit', label: 'Professional Media Kit', hint: 'ZIP · full press bundle' },
  { key: 'bio', label: 'Professional Biography', hint: 'Short & long versions' },
  { key: 'headshots', label: 'Official Headshots', hint: 'High-resolution imagery' },
  { key: 'logos', label: 'Official Logo Package', hint: 'PNG · SVG · EPS' },
  { key: 'brand-guidelines', label: 'Brand Guidelines', hint: 'Colors, type, usage' },
  { key: 'ai-certifications', label: 'AI Certifications', hint: 'Verified credentials' },
  { key: 'company-fact-sheet', label: 'Company Fact Sheet', hint: 'The ecosystem at a glance' },
];

export const RESOURCES_ITEMS = [
  { key: 'templates', label: 'Business Templates', body: 'Founder-tested operating documents, decks, and frameworks.', url: '/resources/business-templates' },
  { key: 'ai-resources', label: 'AI Resources', body: 'Guides on deploying AI inside a founder-led company.', url: '/resources/ai-resources' },
  { key: 'insights', label: 'Founder Insights', body: 'Essays and dispatches from the desk of Toia Wallace.', url: '/resources/founder-insights' },
  { key: 'newsletter', label: 'The Journal', body: 'A quiet monthly letter for founders building with intention.', url: '/journal' },
  { key: 'digital-products', label: 'Digital Products', body: 'Curated founder products delivered instantly.', url: '/resources/digital-products' },
];

export const INSIGHTS = [
  { kind: 'ESSAY', title: 'Why the next great companies will feel like fashion houses.', meta: 'Long-form · 8 min read' },
  { kind: 'VIDEO', title: 'On building companies without losing yourself.', meta: 'Keynote · 22 min' },
  { kind: 'KEYNOTE', title: 'AI is a design decision, not a department.', meta: 'AI Summit · 2025' },
  { kind: 'LINKEDIN', title: 'A note on quiet ambition.', meta: 'LinkedIn · This week' },
];

export const JOURNAL = [
  {
    slug: 'built-a-business-in-1-hour-with-ai',
    hidden: true,
    kind: 'FROM MY DESK',
    title: 'How I Built a Business in 1 Hour with AI',
    dek: 'The story behind CEO Intelligence, why I built an AI Business Builder that can move an idea from inspiration to launch in as little as sixty minutes.',
    body: [
      'A year ago I was sitting with a founder who had been circling the same idea for eighteen months. She had the vision. She had the discipline. What she didn\u2019t have was a way to compress the distance between the idea and the launch. That afternoon, we started building CEO Intelligence.',
      'CEO Intelligence is not another dashboard. It is not a CRM. It is not an executive operating system. It is an AI Business Builder, a guided platform that helps aspiring entrepreneurs transform an idea into a real business in as little as one hour. Validation. Brand. Offer. Pricing. Launch strategy. All of it, guided.',
      'I presented the full framework live at the AI in Action Virtual Summit, walking through exactly how a founder can move from idea to launch inside CEO Intelligence. If you want to see it in action rather than read about it, watch the presentation, the framework is unchanged and the demonstration is the fastest way to understand what we are building.',
      'For industry-specific businesses, laboratories, agencies, real estate, the journey continues inside our vertical platforms like LabFounders HQ. CEO Intelligence is the beginning. The industry platforms are the acceleration.',
      'If you want to be among the first to build inside CEO Intelligence, join the waitlist. If you\u2019re curious, watch the summit presentation. If you\u2019re building something bigger, I want to meet you.',
    ],
    date: 'July 2026',
    readTime: '6 min read',
    cta: {
      label: 'Watch the AI in Action Summit Presentation',
      url: 'https://www.youtube.com/watch?v=fSKIK0d9jso',
      external: true,
    },
    secondaryCta: {
      label: 'Join the CEO Intelligence Waitlist',
      to: '/contact?kind=business&subject=CEO+Intelligence+Waitlist',
    },
  },
  {
    slug: 'ecosystem-not-a-business',
    kind: 'FROM MY DESK',
    title: "Why I'm Building an Ecosystem, Not Just a Business",
    dek: 'A look into the vision behind building multiple companies that work together to create lasting impact.',
    body: [
      'When people ask what I do, the honest answer is that I build ecosystems. I don\u2019t start companies to sell services, I start companies because a specific founder deserves better infrastructure.',
      'Each venture inside my portfolio is designed to reinforce the others. LabFounders HQ gives lab founders a place to build. Altura opens the door to global real estate. Move MODE is the wellness lifestyle brand. Between Us Convos is the relationship media brand exploring love, partnership, and everyday life. Every one of them shares the same operating philosophy: quiet, considered, and enduring.',
      'A single business can be a career. An ecosystem is a body of work.',
    ],
    date: 'July 2026',
    readTime: '6 min read',
  },
  {
    slug: 'lessons-labfounders-hq',
    kind: 'FROM MY DESK',
    title: 'Lessons From Building LabFounders HQ',
    dek: 'Reflections on creating a SaaS platform for laboratory entrepreneurs and what I\u2019ve learned throughout the journey.',
    body: [
      'LabFounders HQ began as a private observation: lab founders were carrying too much weight and too little infrastructure. So we built one.',
      'The lessons are the same lessons every founder learns twice, go slower on the product, faster on the community, and never confuse activity with progress. Everything I know about scale, I learned from a laboratory.',
    ],
    date: 'June 2026',
    readTime: '5 min read',
  },
  {
    slug: 'ai-will-empower-founders',
    kind: 'FROM MY DESK',
    title: "The Future of AI Won't Replace Founders, It Will Empower Them",
    dek: 'My perspective on how AI is changing entrepreneurship and why strategic thinking matters more than ever.',
    body: [
      'AI is not the founder. AI is the operating layer that lets the founder be more of themselves, more strategic, more editorial, more precise.',
      'What we lose to AI is not judgment. What we lose is friction. The founder who understands that will build businesses at a different frequency.',
    ],
    date: 'June 2026',
    readTime: '4 min read',
  },
  {
    slug: 'building-altura',
    kind: 'FROM MY DESK',
    title: 'Building Altura Global RE',
    dek: 'The vision behind creating a global opportunities platform focused on international real estate and investment.',
    body: [
      'Altura Global RE was born out of a personal question: what does it mean to own the world with intention? I was tired of watching founders build wealth in one country and lose it in another.',
      'Altura is a curated door, into markets, residencies, and lifestyles that most founders don\u2019t know are open to them.',
    ],
    date: 'May 2026',
    readTime: '5 min read',
  },
  {
    slug: 'behind-ceo-intelligence',
    hidden: true,
    kind: 'FROM MY DESK',
    title: 'Behind CEO Intelligence',
    dek: 'Why I\u2019m building the AI Business Builder, a platform to help entrepreneurs turn an idea into a real business in as little as one hour.',
    body: [
      'CEO Intelligence is not a business dashboard. It is not a CRM. It is not an executive OS. It is an AI Business Builder, designed to help aspiring entrepreneurs transform an idea into a real business in as little as one hour.',
      'Most founders don\u2019t need more software. They need a starting point. They need a guide that helps them validate the idea, name the business, position the brand, build the offer, price it correctly, and prepare for launch. CEO Intelligence is that guide, powered by AI.',
      'For industry-specific businesses, laboratories, agencies, real estate, the journey continues inside our vertical platforms like LabFounders HQ. CEO Intelligence is the beginning. The industry platforms are the acceleration.',
    ],
    date: 'May 2026',
    readTime: '5 min read',
  },
];

export const MANIFESTO = {
  eyebrow: 'The Vision',
  title: 'A quiet architect of modern ventures.',
  body:
    'I don\u2019t just build businesses. I build systems that help other people create businesses, opportunities, and generational impact. Every company I create is designed to solve a meaningful problem, empower entrepreneurs, and leave the world better than I found it. This is only the beginning.',
  signature: 'Toia Wallace, Founder',
};

export const ECOSYSTEM = {
  hub: { label: 'Toia Wallace', role: 'Founder' },
  rings: [
    {
      title: 'Industry Platforms',
      nodes: [
        { name: 'LabFounders HQ', to: '/companies#labfounders-hq' },
        { name: 'Altura Global RE', to: '/companies#altura-global-re' },
        { name: 'Move MODE', to: '/companies#movemode' },
        { name: 'Future Ventures', to: '/companies#future-ventures' },
      ],
    },
    {
      title: 'Presence',
      nodes: [
        { name: 'Speaking', to: '/speaking' },
        { name: 'Founder Journal', to: '/journal' },
        { name: 'Now', to: '/now' },
        { name: 'Media', to: '/media' },
      ],
    },
  ],
};

export const NOW_PAGE = {
  lastUpdated: 'July 2026',
  intro:
    'This page is my digital \u201cNow\u201d page, a snapshot of what I\u2019m actively building, learning, and focusing on at this moment. As priorities evolve, so will this page.',
  currentFocus:
    'Building a founder ecosystem, quietly, deliberately, and in the open. Composing the operating layer for the next decade of my work.',
  currentlyBuilding: [
    { name: 'LabFounders HQ', body: 'Building the operating system for laboratory entrepreneurs.', url: 'https://labfoundershq.com/' },
    { name: 'Altura Global RE', body: 'Creating a global opportunities platform focused on international real estate, investing, and residency education.', url: 'https://alturagroupre.com/' },
    { name: 'IAmToiaWallace.com', body: 'Building my Founder HQ and personal brand ecosystem.', url: 'https://IAmToiaWallace.com' },
  ],
  buildingNext: [
    { name: 'Move MODE', body: 'The fitness and wellness lifestyle brand.' },
    { name: 'Between Us Convos', body: 'The relationship media brand exploring love, partnership, and everyday life.' },
  ],
  speaking: ['Conferences', 'Corporate events', 'Universities', 'Workshops', 'Podcasts', 'Leadership events'],
  learning: ['Artificial Intelligence', 'SaaS Product Development', 'Founder-Led Growth', 'Global Business Expansion', 'Product Strategy', 'Executive Leadership'],
  reading: ['Leadership', 'Business Strategy', 'Technology', 'AI', 'Entrepreneurship', 'Wealth Building'],
  recentWins: [
    'Founder HQ (IAmToiaWallace.com) launched, the ecosystem now has a home.',
    'LabFounders HQ founding cohort in motion.',
    'Featured as a speaker on artificial intelligence and business transformation.',
    'Executive brand system finalized, typography, photography, and voice codified.',
  ],
  upcomingLaunches: [
    { name: 'Altura Global RE Platform', body: 'Curated markets, Portugal, Dubai, Panama, Caribbean.' },
    { name: 'Between Us Convos', body: 'New episodes exploring love, dating, commitment, and building a life together.' },
  ],
  philosophy:
    'I am not building a personal brand. I am building infrastructure, for the founders coming next, and for the founder I am still becoming.',
  upcoming: [
    'Continued development of LabFounders HQ',
    'Launch of Altura Global RE',
    'Speaking engagements and founder events',
    'Growing the Founder Journal',
  ],
};

export const PARTNERS_PAGE = {
  bio: {
    short:
      'Toia Wallace is a founder, technology entrepreneur, and AI business transformation strategist building a portfolio of ventures across technology, media, education, and real estate.',
    long:
      'Toia Wallace is a founder, technology entrepreneur, and AI business transformation strategist. She builds a growing portfolio of ventures across technology, media, education, and real estate, including LabFounders HQ, Altura Global RE, Move MODE, and Between Us Convos. Her work sits at the intersection of artificial intelligence and modern business strategy. She speaks internationally on AI, entrepreneurship, and the future of founder-led companies.',
  },
  certifications: [
    { name: 'AI Business Transformation', body: 'Advanced credential in enterprise AI deployment strategy.' },
    { name: 'AI Summit Speaker', body: 'Featured speaker on the future of AI in business.' },
    { name: 'Executive AI Strategy', body: 'Executive-level curriculum in strategic AI adoption.' },
  ],
  brandAssets: [
    { key: 'speaker-bio', label: 'Speaker Bio', hint: 'Short & long versions' },
    { key: 'headshots', label: 'Professional Headshots', hint: 'High-resolution imagery' },
    { key: 'company-logos', label: 'Company Logos', hint: 'Ecosystem lockups' },
    { key: 'founder-photos', label: 'Founder Photos', hint: 'Editorial photography' },
    { key: 'brand-guidelines', label: 'Brand Guidelines', hint: 'Colors, typography, usage' },
    { key: 'speaker-one-sheet', label: 'Speaker One-Sheet', hint: 'PDF · single-page overview' },
    { key: 'media-one-sheet', label: 'Media One-Sheet', hint: 'PDF · press-ready summary' },
    { key: 'book-cover', label: 'Book Cover', hint: 'Faith Got Me Here · assets' },
    { key: 'press-assets', label: 'Downloadable Press Assets', hint: 'ZIP · full press bundle' },
  ],
  audienceTakeaways: [
    'A precise mental model for building companies in the AI era.',
    'How to design a business as an ecosystem, not a service.',
    'The founder\u2019s playbook for deploying AI without losing yourself.',
    'Case studies from LabFounders HQ and Altura Global RE.',
  ],
};
